import F from "gsap";
import { Box3 as S, Vector3 as n, MathUtils as T } from "three";
const z = ({ orbit: o, camera: t, target: i, invalidate: c, direction: l = o.object.getWorldDirection(new n()) }) => {
  const s = new S().setFromObject(i), p = s.getSize(new n()).length(), r = s.getCenter(new n()), a = p * 0.5, g = T.DEG2RAD * t.fov * 0.5, v = a / Math.tan(g), w = l.clone().multiplyScalar(-v).add(r), f = t.position.clone(), m = w.clone(), d = o.target.clone(), h = r.clone(), e = { v: 0 };
  return new Promise((x) => F.to(e, {
    v: 1,
    duration: 0.5,
    onUpdate: () => {
      t.position.lerpVectors(f, m, e.v), o.target.lerpVectors(d, h, e.v), c && c();
    },
    onComplete: x
  }));
};
export {
  z as FitToFrame
};
//# sourceMappingURL=index11.js.map
